// extracted by css-extract-rspack-plugin
export default {"root":"tNj3Uq"};